import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 72px;
  width: 100%;

  max-width: 920px;

  margin: 0 auto;
  margin-top: 32px;

  padding: 0 1.5rem;

  overflow: hidden;

  @media only screen and (min-width: 800px) {
    padding: 0;

    .loading-block {
      height: 800px;
    }
  }
`
